import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { DetailsContainer, Footer, Title, Content, Body } from '../DefaultStyles/Shared';
import { Container } from '../DefaultStyles/Details';
import ShareDrawer from '../../components/ShareDrawer';
import VideoPlayer from '../../components/Video/Video';

import {
    onBackWithinCard,
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { isLongText } from '../../components/Shared/commonFunctions';
import { ActionTypes, CardTypes } from '../../utils/enums';

const Video = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body>
            <WidgetHeader />
            <Content isVideoCard={true} isSingleAction={true}>
                <Title
                    isShortText={!isLongText(props.cardTitle, 28)}
                    isLongText={isLongText(props.cardTitle, 60)}
                    isExtraLongText={isLongText(props.cardTitle, 95)}
                    isVideoCard={true}
                    onClick={e => {
                        props.setOverlayPartnerVisible(true, e, false);
                    }}
                    dangerouslySetInnerHTML={{
                        __html: props.cardTitle
                    }}
                />
                <DetailsContainer id="videoContainer" isVideoCard={true}>
                    <VideoPlayer
                        url={props.videoUrl}
                        autoplay={!props.isIOS && !props.isVideoFrontCard}
                        muted={props.isVideoFrontCard}
                        isLongText={isLongText(props.cardTitle, 35)}
                        beforeAdvancing={() =>
                            props.setExitingCardProps('video', props, props.activeAction)
                        }
                    />
                </DetailsContainer>
            </Content>
            <Footer>
                <ShareDrawer
                    beforeBack={() => {
                        props.setExitingCardProps('video', props, props.activeAction);
                    }}
                    goBack={() => {
                        return props.card.type === CardTypes.actionChoice
                            ? props.onBackWithinCard(
                                  props.actionIdentifier,
                                  props.card,
                                  true,
                                  true
                              )
                            : null;
                    }}
                    fullwidth={props.card.type === CardTypes.actionChoice}
                    rightAlign={props.card.type !== CardTypes.actionChoice}
                    hasBackButton={props.card.type === CardTypes.actionChoice}
                    backgroundColor={'#fff'}
                />
            </Footer>
        </Body>
    </Container>
);

Video.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    card: PropTypes.object.isRequired,
    cardTitle: PropTypes.string.isRequired,
    isIOS: PropTypes.bool.isRequired,
    isVideoFrontCard: PropTypes.bool.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    videoUrl: PropTypes.string
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'video',
            ['/video', '/video/start'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            activeAction: state.widget.activeAction,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            cardTitle: state.widget.cards[
                state.widget.activeAction.order - 1
            ].heading.replace(/@articleUrl/g, state.widget.articleUrl),
            videoUrl:
                state.widget.activeAction.type === 'video'
                    ? state.widget.activeAction.url
                    : null,
            isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
            isVideoFrontCard:
                state.widget.cards[state.widget.activeAction.order - 1].order.value ===
                    1 && state.widget.activeAction.type === 'video'
        };
    },
    {
        onBackWithinCard,
        setExitingCardProps,
        setOverlayPartnerVisible
    },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Video) return true;

            return next === prev;
        }
    }
)(Video);
